<template>
  <ion-page>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-buttons slot="start" v-if="backFn">
          <ion-button fill="clear" @click="backFn()">
            <ion-icon color="light" :icon="chevronBack"/>
          </ion-button>
        </ion-buttons>
        <ion-title color="light"> {{ props.title }}</ion-title>
        <ion-buttons slot="end" v-show="!props.suppressClose">
          <ion-button fill="clear" @click="modalController.dismiss()">
            <ion-icon color="light" :icon="closeOutline"/>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding ion-text-center">
      <slot name="content"/>
    </ion-content>
    <ion-footer>
      <slot name="buttons"/>
    </ion-footer>
  </ion-page>
</template>

<script setup>
import {chevronBack, closeOutline} from 'ionicons/icons';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonPage,
  IonTitle,
  IonToolbar,
  modalController,
} from "@ionic/vue";

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  suppressClose: {
    type: Boolean,
    default: false
  },
  backFn: {
    type: Function
  }
});
</script>
